module.exports = __webpack_public_path__ + "media/v2/components/Blog/shared/img/cover_img-54d381aa29052a2796fff612266db7c6.jpg";